import { Action,
  config,
  defaultProcessingSaga,
  defaultResponseProcessing,
  fetchAuthSaga,
  FetchResponse } from '@triare/auth-redux';
import { put, delay, takeLatest, call } from 'redux-saga/effects';
import { actions, ArticleStatus } from './index';
import { WithArticleTypeProps } from '../../components/Pages/Articles/types';
import { Seo } from '../../types/seo';

export type ArticleCreateData = { id: string };

export type ArticleCreateResponse = ArticleCreateData

export interface ArticleCreateBody extends WithArticleTypeProps {
  name: string;
  description: string;
  fileId: string | null;
  videoId?: string | null;
  status: ArticleStatus;
  tags?: { name: string, id?: string }[];
  tagIds?: string[];
  tagList?: string[];
  authorImageId?: string | null;
  authorName?: string;
  authorDescription?: string;
  slug: string;
  seo: Seo;
}

export const articleCreate = (payload: ArticleCreateBody): Action<ArticleCreateBody> => ({
  type: actions.articleCreateTrigger.toString(),
  payload,
});

export const articleCreateClear = (): Action => ({
  type: actions.articleCreateClear.toString(),
});

export const articleCreateErrorClear = (): Action => ({
  type: actions.articleCreateErrorReset?.toString(),
});

export function* articleCreateRequestSaga({ payload }: Action<ArticleCreateBody>) {
  // eslint-disable-next-line no-unused-expressions,@typescript-eslint/no-unused-expressions
  ({ payload });
  yield put({
    type: actions.articleCreateStart.toString(),
  });

  if (!payload) {
    yield put({
      type: actions.articleCreateError.toString(),
      payload: {
        message: 'ArticleCreate: Parameters not passed.',
      },
    });

    return;
  }

  const response = (yield call(
    fetchAuthSaga,
    `${process.env.REACT_APP_API}admin/articles`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    },
    {},
    config.fetchDelay,
  )) as FetchResponse;

  yield defaultResponseProcessing<ArticleCreateData, ArticleCreateResponse>(
    response,
    actions.articleCreateSuccess.toString(),
    actions.articleCreateError.toString(),
    false,
    (articleCreateData) => articleCreateData,
  );
}

export default function* saga() {
  yield takeLatest(
    actions.articleCreateTrigger.toString(),
    defaultProcessingSaga(
      articleCreateRequestSaga,
      {
        error: actions.articleCreateError.toString(),
        locationCancel: actions.articleCreateClear.toString(),
      },
    ),
  );

  yield takeLatest(actions.articleCreateSuccess.toString(), function* clear() {
    if (config.delaySuccess) {
      yield delay(config.delaySuccess);
    }

    // yield put({
    //   type: actions.articleCreateClear.toString(),
    // });
  });

  yield takeLatest(actions.articleCreateError.toString(), function* errorReset() {
    if (config.delayError) {
      yield delay(config.delayError);
    }

    yield put({
      type: actions.articleCreateErrorReset.toString(),
    });
  });
}
